import { InitComponentStateType, createComponentState } from '@/state';

import { MouseEvent } from 'react';
import { SortDirectionEnum } from '@/models/gen/graphql';

export enum ImportHistorySortColumn {
  IngestStarted = 'ingestStarted',
  Type = 'type',
  ProviderDisplayName = 'provider.displayName',
  Filename = 'filename',
  ImportedBy = 'ingestedByUser',
  Total = 'total',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Unchanged = 'unchanged',
}

export type ImportHistoryTableSortingState = {
  column: ImportHistorySortColumn | undefined;
  direction: SortDirectionEnum | undefined;
  handleSort: (column: ImportHistorySortColumn) => (event: MouseEvent<HTMLTableCellElement>) => void;
  resetSort: () => void;
};

const initImportHistoryTableSortingState: InitComponentStateType<ImportHistoryTableSortingState> = (
  setState
): ImportHistoryTableSortingState => ({
  column: undefined,
  direction: undefined,
  handleSort:
    (column: ImportHistorySortColumn) =>
    (event: MouseEvent<HTMLTableCellElement>): void => {
      event.preventDefault();
      event.stopPropagation();
      setState((current) => {
        const isSameColumn = current.column === column;
        let newDirection: SortDirectionEnum | undefined;
        if (!isSameColumn) newDirection = SortDirectionEnum.Asc;
        else if (current.direction === SortDirectionEnum.Asc) newDirection = SortDirectionEnum.Desc;
        else if (current.direction === SortDirectionEnum.Desc) newDirection = undefined;
        else newDirection = SortDirectionEnum.Asc;
        return { ...current, column: newDirection ? column : undefined, direction: newDirection };
      });
    },
  resetSort: (): void => setState((current) => ({ ...current, column: undefined, direction: undefined })),
});

const useImportHistoryTableSorting = createComponentState<ImportHistoryTableSortingState>(initImportHistoryTableSortingState);

export default useImportHistoryTableSorting;
